/**
 * Tela de falha de configuracao.
 *
 * `env.ts` derruba o app quando falta variavel — isso e proposital. Mas o erro
 * acontece no carregamento do modulo, antes de qualquer componente montar, onde
 * um ErrorBoundary do React nao alcanca. Sem esta tela, o resultado e uma
 * pagina em branco: falha fechada, mas muda. E a pagina em branco aparece
 * justamente na instalacao, para quem ainda nao sabe o que procurar.
 */
export function FatalError({ error }: { error: unknown }) {
  const mensagem = error instanceof Error ? error.message : String(error)

  return (
    <main className="mx-auto flex min-h-svh max-w-xl flex-col justify-center gap-4 p-6">
      <h1 className="text-2xl font-semibold tracking-tight">
        O app não subiu — falta configuração.
      </h1>
      <pre className="overflow-x-auto rounded-lg border border-destructive/40 bg-destructive/5 p-4 text-sm whitespace-pre-wrap text-destructive">
        {mensagem}
      </pre>
      <p className="text-sm text-muted-foreground">
        Em desenvolvimento, conferir o <code>.env.local</code>. Em produção, as
        variáveis do build no GitHub Actions. O passo a passo está em{' '}
        <code>docs/novo-projeto.md</code>.
      </p>
    </main>
  )
}
